import { createApp, type App } from 'vue';
import { type ApplicationInsightsOptions } from '@application-insights/aiSetup';
import axios from 'axios';
import { appDefaults } from '@app-lib/index';
import '@tailwind-preset/tailwind.css';
import application from './App.vue';
import { router } from './router';

const app: App<Element> = createApp(application);

const aiOptions: ApplicationInsightsOptions = {
  applicationName: 'menu-app',
  axios,
  trackInitialPageView: true,
};

app.use(appDefaults, aiOptions).use(router).mount('#sb-menu-app');
